import { combineReducers } from 'redux';
import personMeReducer from './me.reducer';
import featureTogglesReducer from './featureToggles.reducer';

export default combineReducers({
  me: personMeReducer,
  featureToggles: featureTogglesReducer,
});
